// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"styles_searchWrapper__QDrLF","filterBtn":"styles_filterBtn__5Wf76"};